export default {
  QUESTIONGETSUMMARY: 'https://safe.topxinli.com/api/odata/kaka/studentsQuestionnaire/getSummary.xsjs',
  QUESTIONGETDETAIL: 'https://safe.topxinli.com/api/odata/kaka/studentsQuestionnaire/getDetail.xsjs',
  CHANGERESULTSTATUS: 'https://safe.topxinli.com/api/odata/kaka/studentsQuestionnaire/changeResultStatus.xsjs',
  MIDDLE: 'https://safe.topxinli.com/api/odata/Odata.xsodata/Middle',
  ORIGIN: 'https://safe.topxinli.com/api/odata/kaka/Odata.xsodata/Origin',
  STAFFLOGIN: 'https://safe.topxinli.com/api/odata/staff/fgwLogin',
  STAFFREGISTER: 'https://safe.topxinli.com/api/odata/staff/fgw/register',
  PUTPROFILE: 'https://safe.topxinli.com/admin/opRecord'
}



// WEBPACK FOOTER //
// ./src/store/url.js